var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    button: true,
    "button--full-width": (_vm.width === "available"),
  },attrs:{"type":_vm.type,"title":_vm.title,"disabled":_vm.disabled,"id":_vm.id,"name":_vm.name,"tabindex":_vm.tabIndex}},[(_vm.icon)?_c('span',{staticClass:"button__icon"}):_vm._e(),(_vm.showText)?_c('span',{staticClass:"button__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }